import React from "react";
import { Grid } from "@material-ui/core";
import IconBoxComponent from "../../../components/website/icon-box.component";
import PhoneIcon from "@material-ui/icons/Phone";
import DraftsIcon from "@material-ui/icons/Drafts";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import HeaderComponent from "../../../components/navigation/navigation.component";
import Footer from "../../../components/footer/footer.component";

const ContactUs = () => {
  return (
    <React.Fragment>
      <HeaderComponent />
      <Grid container>
        <Grid item xs={12} sm={4}>
          <IconBoxComponent
            icon={PhoneIcon}
            headerText="Our Phone Contact"
            textBody="You can call us at +2348064648720"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <IconBoxComponent
            icon={DraftsIcon}
            headerText="Our Email Address"
            textBody="You can email us at info@tractrac.co"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <IconBoxComponent
            icon={LocationOnIcon}
            headerText="Our Abuja Office"
            textBody="Our office is at #12 Ebitu Ukiwe Street, Jabi, Abuja"
          />
        </Grid>
      </Grid>
      <Grid>
        <Grid>
          <iframe
            title="Tractrac Jabi Address"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3939.99590260683!2d7.422526676044006!3d9.064136590998562!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104e74da2e4a3ceb%3A0xebfebd814d3adfc5!2s12%20Ebitu%20Ukiwe%20St%2C%20Jabi%20900108%2C%20Abuja%2C%20Federal%20Capital%20Territory!5e0!3m2!1sen!2sng!4v1687355976876!5m2!1sen!2sng"
            width="100%"
            height="450"
            style={{ border: "none" }}
            allowfullscreen=""
            loading="lazy"
          />
        </Grid>
      </Grid>
      <Footer />
    </React.Fragment>
  );
};

export default ContactUs;
